<template>
    <button class="btn-primary" :class="sizeClass" :disabled="disabled || loading" @click="handleClick">
        <span v-if="loading" class="btn-loading">
            <span class="btn-spinner"></span>
            {{ $t('common.loading') }}
        </span>
        <slot v-else>{{ $t('common.button') }}</slot>
    </button>
</template>

<script setup>
    import { computed, defineProps, defineEmits } from 'vue';

    const props = defineProps({
    disabled: {
        type: Boolean,
        default: false
    },
    loading: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'md',
        validator: (value) => ['sm', 'md', 'lg'].includes(value)
    }
    });

    const sizeClass = computed(() => `btn-${props.size}`);

    const emits = defineEmits(['click']);

    function handleClick(event) {
        if (props.disabled) {
            event.preventDefault();
            return;
        }
        emits('click', event);
    }
</script>

<style scoped>
.btn-primary {
    font-family: var(--font-family-primary);
    font-size: var(--font-size-body);
    line-height: var(--line-height-btn);
    font-weight: var(--font-weight-medium);
    color: var(--color-white);
    text-align: center;

    width: 100%;
    padding: var(--padding-btn-md);
    border: none;
    background: var(--gradient-primary);
    border-radius: var(--border-radius-lg);
}

.btn-primary.btn-sm {
    padding: var(--padding-btn);
    font-size: var(--font-size-description);
}

.btn-primary.btn-lg {
    padding: var(--padding-btn-lg);
}

.btn-primary:hover {
    background: var(--gradient-primary-hover);
}

.btn-primary:active {
    background: var(--gradient-primary-active);
}

.btn-primary:disabled {
    background: var(--bg-disabled);
}

.btn-loading {
    display: inline-flex;
    align-items: center;
    gap: var(--spacing-sm);
}

.btn-spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid currentColor;
    border-top-color: transparent;
    border-radius: 50%;
    animation: btn-spin 0.6s linear infinite;
}

@keyframes btn-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
